import { createApp } from 'vue';
import { createPinia } from "pinia";
import VueFileAgent from './components/FileAgent/index';
import { vueDebounce } from 'vue-debounce'
import { SlickList, SlickItem } from 'vue-slicksort';
import { createPersistedState } from 'pinia-plugin-persistedstate'
import tooltip from "@/directives/tooltip";
import axios from 'axios';
import { handleError } from './stores/storeHelper';

// @ts-ignore
function ConfigureApp(rootComponent: any) {

    const app = createApp(rootComponent)
        .use(PiniaInit())
        .directive('debounce', vueDebounce({ lock: true })) //https://www.npmjs.com/package/vue-debounce#typescript-support
        .component('upload-input-with-button', require('./components/UploadInputWithButton.vue').default)
        .component('data-upload-grid', require('./components/DataUpload.vue').default)
        .component('data-upload-details', require('./components/DataUploadDetails.vue').default)
        .component('errors-warnings', require('./components/ErrorsAndWarnings.vue').default)
        .component('errors-warnings-update', require('./components/ErrorsAndWarningsUpdate.vue').default)
        .component('contacts-editor', require('./components/ContactsEditor.vue').default)
        .component('contacts-web-entry', require('./components/ContactsWebEntry.vue').default)
        .component('community-policing-web-entry', require('./components/CommunityPolicingWebEntry.vue').default)
        .component('community-policing-data-exporter', require('./components/CommunityPolicingDataExporter.vue').default)
        .component('reset-password', require('./components/ResetPassword.vue').default)
        .component('change-password', require('./components/ChangePassword.vue').default)
        .component('tasks', require('./components/Tasks.vue').default)
        .component('vfa-sortable-list', SlickList)
        .component('vfa-sortable-item', SlickItem)
        .component('audits', require('./components/Audits.vue').default)
        .component('audit-details', require('./components/AuditDetails.vue').default)
        .component('audit-document-templates', require('./components/AuditDocumentTemplates.vue').default)
        .component('agency-dashboard', require('./components/AgencyDashboard.vue').default)
        .component('users', require('./components/Users.vue').default)
        .component('notices', require('./components/Notices.vue').default)
        .use(VueFileAgent);

    app.directive("tooltip", tooltip);


    app.config.errorHandler = (err: any) => {
        console.error(err);
    }

    axios.interceptors.response.use(function (response) {
        // status codes within the range of 2xx cause this function to trigger
        if (typeof (response.data) == "string" && response.data.indexOf('sign-in') > -1) {
            window.location.href = "signin.aspx";
            return Promise.reject(new Error("Redirecting to sign-in page"));
        }
        return response;
    }, function (error) {
        // everything else goes here
        handleError(error);

        return Promise.reject(error);
    });
    
    return app;
}



function PiniaInit() {
    var pinia = createPinia();

    //Plugins for pinia can be added below
    //pinia.use(<insert plugin function here>)
    pinia.use(createPersistedState({
        storage: sessionStorage,
    }));

    pinia.use(({ store }) => {
        if (store.$id == "userProfile") {
            store.permissions = window["permissions"];
        }
    })
    return pinia;
}
// @ts-ignore
window.$ConfigureApp = ConfigureApp;


